import { render } from "./SalesList.vue?vue&type=template&id=f3d239b6&scoped=true"
import script from "./SalesList.vue?vue&type=script&lang=js"
export * from "./SalesList.vue?vue&type=script&lang=js"

import "./SalesList.vue?vue&type=style&index=0&id=f3d239b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d239b6"]])

export default __exports__